import { filehandlingService } from "@/services/filehandling.service";

const actions = {
  // @ts-ignore
  download({ commit }, { file, name }) {
    return filehandlingService.download(file, name);
  },
  downloadSubmissionModel({ commit }, { file, name }) {
    return filehandlingService.downloadSubmissionModel(file, name);
  },
  upload({ commit }, { submission, callback }) {
    return filehandlingService.upload(submission, callback);
  }
};

export const filehandlingManager = {
  namespaced: true,
  actions
};
